import { AutoMap } from "@automapper/classes";
import { Cassette } from "./cassette";
import { Task } from "./task";

export class Operator {
    @AutoMap()
    Position!: number;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;
    @AutoMap(() => [Cassette])
    CassetteList: Cassette[] = [];
    @AutoMap(() => [Task])
    TaskList: Task[] = [];

    public constructor(init?: Partial<Operator>) {
        Object.assign(this, init);
    }
}